module.exports = __webpack_public_path__ + "static/media/hamza.b3327f4b.jpg";